module.exports = __webpack_public_path__ + "static/media/picture2.5ca49fc4.png";